import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/_default-store/Templates/SearchPage.rt'
import { SearchHeader } from 'Components'
import { FacetPanel } from 'Components'
import { SearchResult } from 'Components'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonAdaptable from 'Stores/_default-store/Templates/searchBox/dialogButtonAdaptable.rt'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/bigcommerce-turn14-stores/Templates/fitmentSearch/homeVehicleWidget.rt'
import TemplatefitmentSearchheaderVehicleWidget from 'Stores/bigcommerce-turn14-stores/Templates/fitmentSearch/headerVehicleWidget.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/bigcommerce-turn14-stores/Templates/fitmentSearch/verifyFitment.rt'
import TemplatefitmentSearchverifyFitmentStatus from 'Stores/bigcommerce-turn14-stores/Templates/fitmentSearch/verifyFitmentStatus.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import TemplatefitmentSearchfitmentTableTab from 'Stores/bigcommerce-turn14-stores/Templates/fitmentSearch/fitmentTableTab.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/bigcommerce-turn14-stores/Templates/product/relatedItems.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialog from 'Stores/_default-store/Templates/FacetDialog.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/_default-store/Templates/fitmentSearch/dialog.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/bigcommerce-turn14-stores/Templates/fitmentSearch/singleVehicleGarage.rt'

export const compMap = {
  SearchPage,
SearchHeader,
FacetPanel,
SearchResult,
SearchBoxDialogButton,
VehicleWidget,
Garage,
VerifyFitment,
FacetTiles,
FitmentTable,
RelatedItems,
FacetDialog,
VehicleWidgetDialog,
SearchBoxDialog,
SingleVehicleGarage
}
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'searchBox/dialogButtonAdaptable': TemplatesearchBoxdialogButtonAdaptable,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'fitmentSearch/headerVehicleWidget': TemplatefitmentSearchheaderVehicleWidget,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'fitmentSearch/verifyFitmentStatus': TemplatefitmentSearchverifyFitmentStatus,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'fitmentSearch/fitmentTableTab': TemplatefitmentSearchfitmentTableTab,
'product/relatedItems': TemplateproductrelatedItems,
'FacetDialog': TemplateFacetDialog,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage
};